export default "__VITE_ASSET__DYeAv$km__"